export enum TestCentreTypeEnum {
  Theory = 1,
  Practical = 2,
}
